<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
         viewBox="0 0 29 29">
        <path
                ref="thirdFromRightLine"
                id="thirdFromRightLine"
                fill="#CFD8DC"
                d="M16.975,17.975 A0.999,0.999,0,0,1,16.268,16.268 C16.733,15.802,17,15.158,17,14.5
S16.733,13.198,16.268,12.732 A0.999,0.999,0,1,1,17.682,11.318
C18.52,12.156,19,13.315,19,14.5 S18.52,16.844,17.682,17.682
A1,1,0,0,1,16.975,17.975 Z"/>
        <path
                ref="secondFromRightLine"
                id="secondFromRightLine"
                fill="#CFD8DC"
                d="M19.804,20.803 A0.999,0.999,0,0,1,19.097,19.096 C20.307,17.886,21,16.211,21,14.5
S20.307,11.114,19.097,9.904 A0.999,0.999,0,1,1,20.511,8.49
C22.093,10.072,23,12.263,23,14.5 S22.093,18.928,20.511,20.51
A0.995,0.995,0,0,1,19.804,20.803 Z"/>
        <path
                ref="rightMostLine"
                id="rightMostLine"
                fill="#CFD8DC"
                d="M22.632,23.632 A0.999,0.999,0,0,1,21.925,21.925 C23.879,19.97,25,17.264,25,14.5
S23.879,9.03,21.925,7.075 A0.999,0.999,0,1,1,23.339,5.661
C25.666,7.988,27,11.21,27,14.5 S25.666,21.012,23.339,23.339
A0.997,0.997,0,0,1,22.632,23.632 Z"/>
        <path
                ref="thirdfromLeftLine"
                fill="#CFD8DC"
                d="M12.025,17.975 A0.997,0.997,0,0,1,11.318,17.682 C10.48,16.844,10,15.685,10,14.5
S10.48,12.156,11.318,11.318 A0.999,0.999,0,1,1,12.732,12.732
C12.267,13.198,12,13.842,12,14.5 S12.267,15.802,12.732,16.268
A0.999,0.999,0,0,1,12.025,17.975 Z"/>
        <path
                ref="secondfromLeftLine"
                id="secondfromLeftLine"
                fill="#CFD8DC"
                d="M9.196,20.803 A0.997,0.997,0,0,1,8.489,20.51 C6.907,18.928,6,16.737,6,14.5
S6.907,10.072,8.489,8.49 A0.999,0.999,0,1,1,9.903,9.904
C8.693,11.114,8,12.789,8,14.5 S8.693,17.886,9.903,19.096
A0.999,0.999,0,0,1,9.196,20.803 Z"/>
        <path
                ref="leftMostLine"
                fill="#CFD8DC"
                d="M6.368,23.632 A0.997,0.997,0,0,1,5.661,23.339 C3.334,21.012,2,17.79,2,14.5
S3.334,7.988,5.661,5.661 A0.999,0.999,0,1,1,7.075,7.075
C5.121,9.03,4,11.736,4,14.5 S5.121,19.97,7.075,21.925
A0.999,0.999,0,0,1,6.368,23.632 Z"/>
        <path
                ref="dot"
                id="dot"
                fill="#CFD8DC"
                d="M14.5,13.5 C15.0523,13.5,15.5,13.9477,15.5,14.5
C15.5,15.0523,15.0523,15.5,14.5,15.5 C13.9477,15.5,13.5,15.0523,13.5,14.5
C13.5,13.9477,13.9477,13.5,14.5,13.5 Z"/>
    </svg>
</template>

<script>
    import {TweenMax, Sine} from 'gsap'

    export default {
        name: "JulioNetworkIcon",
        props: {
            show: {
                type: Boolean,
                default: false
            },
        },
        watch: {
            show: function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    if (newVal) {
                        this.startRotation()
                        this.startOtherRotation()
                    } else {
                        this.clearAnimation()
                    }
                }
            }
        },
        methods: {
            startRotation() {
                this.rotationAnimation(this.$refs.secondfromLeftLine, 360, 0.3)
                this.rotationAnimation(this.$refs.rightMostLine, -360, 0.3)
                this.rotationAnimation(this.$refs.thirdFromRightLine, -720, 0.3)
            },
            startOtherRotation() {
                this.rotationAnimation(this.$refs.thirdfromLeftLine, -720, 0.4)
                this.rotationAnimation(this.$refs.leftMostLine, 360, 0.4)
                this.rotationAnimation(this.$refs.secondFromRightLine, -720, 0.4)
            },
            clearAnimation() {
                this.reset(this.$refs.leftMostLine)
                this.reset(this.$refs.secondfromLeftLine)
                this.reset(this.$refs.thirdfromLeftLine)
                this.reset(this.$refs.secondFromRightLine)
                this.reset(this.$refs.rightMostLine)
                this.reset(this.$refs.thirdFromRightLine)
            },
            rotationAnimation(el, rot, duration) {
                TweenMax.to(el, duration, {
                    rotation: rot,
                    repeat: 1,
                    yoyo: true,
                    svgOrigin: '14.5 14.5',
                    ease: Sine.easeInOut,
                })
            },
            reset(el) {
                TweenMax.set(el, {rotation: 0})
            },

        }
    }
</script>

<style lang="scss" src="../../styles/icons/julionetworkicon.scss" scoped/>